<template>
  <div v-if="getConfirmedBet" class="outcome-overlay">
    <div class="outcome-overlay__backdrop" @click="handleClose"></div>

    <div class="outcome-modal">
      <div class="outcome-modal__close">
        <button @click="handleClose">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
          </svg>
        </button>
      </div>

      <!-- SUCCESS -->
      <div v-if="!getConfirmedBet.is_booked" class="outcome-content">
        <div class="outcome-icon outcome-icon--success">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
          </svg>
        </div>
        <div class="outcome-title outcome-title--success">{{ $t('betAccepted') }}</div>

        <button class="outcome-code-row" @click="copyCode(getConfirmedBet.bet_code, 'main')">
          <span class="outcome-code-label">Bet Code:</span>
          <span class="outcome-code-value">{{ getConfirmedBet.bet_code }}</span>
          <svg v-if="!copiedCodes['main']" xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#22c55e" viewBox="0 0 16 16">
            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
          </svg>
        </button>

        <div class="outcome-actions">
          <button class="outcome-btn outcome-btn--primary" @click="handlePrint">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
              <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"/>
              <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1"/>
            </svg>
            {{ $t('print') }}
          </button>
          <button class="outcome-btn outcome-btn--secondary" @click="handleNewBet">{{ $t('newBet') }}</button>
          <button class="outcome-btn outcome-btn--secondary" @click="handleReloadBet">{{ $t('reloadBet') }}</button>
        </div>
      </div>

      <!-- BOOKED -->
      <div v-else class="outcome-content">
        <div class="outcome-icon outcome-icon--warning">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.75 6L7.5 5.25H16.5L17.25 6V19.3162L12 16.2051L6.75 19.3162V6ZM8.25 6.75V16.6838L12 14.4615L15.75 16.6838V6.75H8.25Z" fill="currentColor"/>
          </svg>
        </div>
        <div class="outcome-title outcome-title--warning">{{ $t('betBooked') }}</div>

        <button class="outcome-code-row" @click="copyCode(getConfirmedBet.bet_code, 'booked')">
          <span class="outcome-code-label">Booking Code:</span>
          <span class="outcome-code-value">{{ getConfirmedBet.bet_code }}</span>
          <svg v-if="!copiedCodes['booked']" xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#22c55e" viewBox="0 0 16 16">
            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
          </svg>
        </button>

        <div class="outcome-actions">
          <button class="outcome-btn outcome-btn--secondary" @click="handleNewBet">{{ $t('newBet') }}</button>
          <button class="outcome-btn outcome-btn--secondary" @click="handleReloadBet">{{ $t('reloadBet') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'BetOutcomeModalAmerican',
  data() {
    return {
      copiedCodes: {},
      copyTimers: {},
    };
  },
  computed: {
    ...mapGetters({
      getConfirmedBet:     'cart/getConfirmedBet',
      getPlatformSettings: 'settings/getPlatformSettings',
      getOddsType:         'odds/getOddsType',
      getShortCode:        'settings/getShortCode',
      getType:             'user/getType',
      getId:               'user/getId',
    }),
  },
  methods: {
    ...mapActions({
      resetCart:         'cart/resetCart',
      clearConfirmedBet: 'cart/clearConfirmedBet',
    }),
    handleClose() {
      if (!this.getConfirmedBet.is_booked) this.resetCart();
      this.clearConfirmedBet();
    },
    handleNewBet() {
      this.$root.$emit('cart_handling', true);
      this.resetCart();
      this.clearConfirmedBet();
    },
    handleReloadBet() {
      this.clearConfirmedBet();
    },
    handlePrint() {
      const code = this.getConfirmedBet?.bet_code;
      if (!code || !this.getPlatformSettings?.print_endpoint) return;
      const base = this.getPlatformSettings.print_endpoint + code;
      const url = this.getShortCode
        ? `${base}&login=${this.getType}&ancestors=${this.getId}&type_odd=${this.getOddsType}`
        : `${base}&type_odd=${this.getOddsType}`;
      window.open(url, '_blank', 'height=600,width=350');
    },
    async copyCode(text, key) {
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        } else {
          const ta = document.createElement('textarea');
          ta.value = text;
          ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
          document.body.appendChild(ta);
          ta.focus(); ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        this.$set(this.copiedCodes, key, true);
        if (this.copyTimers[key]) clearTimeout(this.copyTimers[key]);
        this.copyTimers[key] = setTimeout(() => {
          this.$set(this.copiedCodes, key, false);
        }, 2000);
      } catch (e) {
        console.error('copy failed', e);
      }
    },
  },
  beforeDestroy() {
    Object.values(this.copyTimers).forEach(t => t && clearTimeout(t));
  },
};
</script>

<style scoped>
.outcome-overlay {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
}
.outcome-overlay__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.55);
}
.outcome-modal {
  position: relative;
  background: var(--bg-card);
  border-radius: 12px;
  width: calc(100% - 48px);
  max-width: 400px;
  padding: 16px;
  z-index: 1;
  box-shadow: 0 8px 32px rgba(0,0,0,0.4);
  animation: modalIn 0.22s ease;
}
@keyframes modalIn {
  from { opacity: 0; transform: scale(0.96); }
  to   { opacity: 1; transform: scale(1); }
}
.outcome-modal__close {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 4px;
}
.outcome-modal__close button {
  background: none; border: none; cursor: pointer;
  color: var(--text-op-50-platform); display: flex;
  padding: 4px; border-radius: 4px; transition: color 0.15s;
}
.outcome-modal__close button:hover { color: var(--text-platform); }
.outcome-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 8px 0 4px;
}
.outcome-icon {
  width: 60px; height: 60px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
}
.outcome-icon--success { background: rgba(34,197,94,0.12); color: #22c55e; border: 2px solid rgba(34,197,94,0.3); }
.outcome-icon--warning { background: rgba(245,158,11,0.12); color: var(--warning,#f59e0b); border: 2px solid rgba(245,158,11,0.3); }
.outcome-title { font-size: var(--font-size-7xl); font-weight: 700; text-transform: capitalize; }
.outcome-title--success { color: #22c55e; }
.outcome-title--warning { color: var(--warning, #f59e0b); }
.outcome-code-row {
  width: 100%; display: flex; align-items: center; gap: 8px;
  background: var(--sidebar); border: none; border-radius: 8px;
  padding: 10px 14px; cursor: pointer; transition: background 0.15s;
}
.outcome-code-row:hover { background: rgba(255,255,255,0.07); }
.outcome-code-label { font-size: var(--font-size-xl); color: var(--text-op-50-platform); }
.outcome-code-value {
  font-family: 'Courier New', monospace;
  font-size: var(--font-size-6xl); font-weight: 800;
  color: var(--text-platform); flex: 1; text-align: left;
}
.outcome-actions { display: flex; gap: 8px; width: 100%; flex-wrap: wrap; }
.outcome-btn {
  flex: 1; height: 38px; border-radius: 6px; font-size: var(--font-size-2xl); font-weight: 600;
  cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 6px;
  border: none; transition: all 0.15s; white-space: nowrap; text-transform: capitalize;
}
.outcome-btn--primary { background: var(--btn-background); color: var(--btn-text, #fff); }
.outcome-btn--primary:hover { opacity: 0.9; }
.outcome-btn--secondary {
  background: transparent;
  border: 1px solid rgba(255,255,255,0.2);
  color: var(--text-platform);
}
.outcome-btn--secondary:hover { background: rgba(255,255,255,0.07); }
</style>
